import React from 'react';
import { matchRoutes } from 'react-router-config';
import { isEmpty } from 'ramda';
import { maths } from '../../../utils';
import routesConfig, { hideHeaderRoutes } from '../../../config/routes';
import Context from '../../layout/Container/Context';

const useShowHeader = () => {
  const { history } = React.useContext(Context);
  const [show, setShow] = React.useState(
    isEmpty(matchRoutes(hideHeaderRoutes, history.location.pathname)),
  );

  React.useEffect(() => {
    // 跳转链接时，监听是否显示头
    const unlisten = history.listen((location) => {
      const shouldShowHeader = isEmpty(matchRoutes(hideHeaderRoutes, location.pathname));
      setShow(shouldShowHeader);
    });
    return () => {
      unlisten();
    };
  });

  return show;
};

const useFooterJudgement = () => {
  const { history } = React.useContext(Context);
  const [showFooter, setShowFooter] = React.useState(!history.location.pathname.includes('/home'));
  const show = useShowHeader(history);

  React.useEffect(() => {
    const judgementFn = (location) => {
      const isFixed = window.tmConfig.isFixedBottom();
      const judgement = !location.pathname.includes('/home') ? isFixed : show;
      setShowFooter(judgement);
    };
    judgementFn(history.location);
    const unlisten = history.listen((location) => {
      judgementFn(location);
    });
    return () => {
      unlisten();
    };
  });

  return showFooter;
};

const useHeightFix = () => {
  const { history } = React.useContext(Context);
  const [shouldFix, setShouldFix] = React.useState(!history.location.pathname.includes('/home'));
  const show = useShowHeader(history);

  React.useEffect(() => {
    const judgementFn = (location) => {
      const isFixed = window.tmConfig.isFixedBottom();
      const judgement = !location.pathname.includes('/home') && !isFixed && show;
      setShouldFix(judgement);
    };
    judgementFn(history.location);
    const unlisten = history.listen((location) => {
      judgementFn(location);
    });
    return () => {
      unlisten();
    };
  });

  return shouldFix;
};

const checkCopiable = (pathname) => {
  const match = matchRoutes(routesConfig, pathname);
  if (isEmpty(match)) return false;
  return !!match[0].route.copy;
};

const useCopiable = () => {
  const { history } = React.useContext(Context);
  const [copiable, setCopiable] = React.useState(() => checkCopiable(history.location.pathname));
  React.useEffect(() => {
    // 跳转链接时，监听是否显示头
    const unlisten = history.listen((location) => {
      setCopiable(checkCopiable(location.pathname));
    });
    return () => {
      unlisten();
    };
  });

  return copiable;
};

const useMainKey = () => {
  const { history } = React.useContext(Context);
  const [mainKey, setMainKey] = React.useState(maths.getSnowFlake());

  React.useEffect(() => {
    let currentPathname = history.location.pathname;
    const unlisten = history.listen((location) => {
      if (location.pathname === currentPathname) {
        setMainKey(maths.getSnowFlake());
      }
      currentPathname = location.pathname;
    });
    return () => {
      currentPathname = undefined;
      unlisten();
    };
  });

  return mainKey;
};

const useMainContainer = () => {
  const copiable = useCopiable();
  const mainKey = useMainKey();
  const shouldFix = useHeightFix();

  return {
    copiable,
    mainKey,
    shouldFix,
  };
};

export default {
  useShowHeader,
  useFooterJudgement,
  useMainContainer,
};
